export const aboutInfo = {
  brandName: '漫画皮',
  slogan: '高清免费漫画，就在漫画皮',
  mission: '让每一位漫画爱好者都能随时随地享受高质量的正版漫画阅读体验。',
  founded: '2018',
  stats: {
    totalComics: 12000,
    totalChapters: 500000,
    dailyActiveUsers: 3500000,
    totalUsers: 85000000,
  },
  story: '漫画皮成立于2018年，由一群热爱漫画的年轻人创立。我们深知漫画爱好者对于优质内容的渴望，因此致力于打造一个内容丰富、体验流畅的在线漫画阅读平台。经过数年的发展，漫画皮已与国内外数百家漫画工作室和出版社建立了合作关系，平台汇集了超过12,000部优质漫画作品，涵盖热血、恋爱、悬疑、奇幻、搞笑、科幻、武侠、都市、冒险等多种类型。我们始终坚持以用户为中心，不断优化阅读体验，让每一位漫画爱好者都能在这里找到属于自己的精神世界。',
  values: [
    { title: '内容为王', desc: '严格筛选每一部作品，确保平台内容质量上乘，为读者提供最好的阅读选择。' },
    { title: '用户体验', desc: '不断优化阅读器性能和界面设计，让翻页如丝般顺滑，沉浸式享受每一话。' },
    { title: '创作者尊重', desc: '与漫画作者和工作室建立公平透明的合作模式，保障创作者的合法权益。' },
    { title: '社区共建', desc: '鼓励读者互动交流，共建积极健康的漫画爱好者社区，分享阅读的快乐。' },
  ],
  media: [
    { outlet: '腾讯动漫', quote: '漫画皮凭借丰富的作品库和流畅的阅读体验，迅速成为国内领先的在线漫画平台之一。', year: '2025' },
    { outlet: '动漫之家', quote: '作为漫画行业的新锐力量，漫画皮在内容版权合作和用户体验上表现突出。', year: '2025' },
    { outlet: '哔哩哔哩漫画', quote: '漫画皮的日活用户持续增长，已成为年轻漫画爱好者最受欢迎的阅读平台之一。', year: '2024' },
    { outlet: '快看漫画', quote: '漫画皮在作品数量和用户规模上都取得了令人瞩目的成绩，未来发展潜力巨大。', year: '2024' },
    { outlet: '有妖气', quote: '漫画皮为国产漫画提供了一个优质的展示窗口，帮助大量优秀创作者触达更广泛的读者。', year: '2024' },
    { outlet: '动漫星空', quote: '凭借出色的产品设计和内容运营能力，漫画皮在漫画阅读APP中好评率名列前茅。', year: '2023' },
  ],
  contact: {
    businessEmail: 'hello@qjmd.cn',
    copyrightEmail: 'hello@qjmd.cn',
    cooperationEmail: 'hello@qjmd.cn',
    address: '北京市朝阳区望京SOHO T1-B座 1806室',
    phone: '010-8888-6666',
    wechat: 'mangapi_official',
    siteLink: '@漫画皮官方微博',
  },
  faqs: [
    {
      question: '漫画皮上的漫画是免费的吗？',
      answer: '是的，漫画皮平台上的所有漫画均免费提供在线阅读。我们通过广告和品牌合作来维持平台运营，确保读者可以无门槛地享受优质漫画内容。',
    },
    {
      question: '漫画皮支持哪些设备阅读？',
      answer: '漫画皮支持PC端网页、iOS和Android移动端App，以及平板设备。您可以在任何设备上登录您的账号，同步阅读进度和个人收藏。',
    },
    {
      question: '如何成为漫画皮的签约作者？',
      answer: '您可以通过版权合作邮箱（hello@qjmd.cn）发送您的作品和简历，我们的编辑团队会在7个工作日内进行审核并回复。我们欢迎所有优秀的漫画创作者加入！',
    },
    {
      question: '漫画的更新频率是怎样的？',
      answer: '不同作品的更新频率有所不同，热门连载作品通常保持每周更新，部分作品可能为双周更或月更。您可以在作品详情页查看具体的更新计划，也可以开启更新提醒功能。',
    },
    {
      question: '遇到阅读问题或BUG怎么办？',
      answer: '您可以通过App内的"意见反馈"功能提交问题，或发送邮件至我们的技术支持邮箱。我们的技术团队会在24小时内处理您的问题。',
    },
  ],
};